import BottomSection from "./components/BottomSection";
import Toolbox from "./components/Toolbox";
import TopSection from "./components/TopSection";
import "../../Index.scss";
import Header from "Dashboard/components/Header";
import { useCallback, useEffect, useState } from "react";
import { IGetStockInputsRequestParams } from "../../domain/IGetStockInputsRequestParams";
import { getStockInputs, getStockReservations } from "./inputSlice";
import { useAppDispatch } from "hooks/hooks";
import usePagingAndSort,
{ IGetPageRequestParams, IUpdateStateAfterSearchParams } from "hooks/pagingAndSort";
import { useForm } from "react-hook-form";

const Input = () => {
  const dispatch = useAppDispatch();

  const defaultGetInputsRequestParams: IGetStockInputsRequestParams = {
    stock: "Lager",
    searchTerm: undefined,
    xxx: null
  };

  const [getInputsRequestParams, setGetInputsRequestParams]
    = useState<IGetStockInputsRequestParams>(
      defaultGetInputsRequestParams);

  const limit = 1000;

  const {
    register: registerSearch,
    handleSubmit: handleSubmitSearch,
    reset: resetSearch,
    control: controlSearch,
    getValues: getValuesSearch,
    setFocus: setFocusSearch,
    setValue: setValueSearch
  } = useForm<IGetStockInputsRequestParams>({
    defaultValues: defaultGetInputsRequestParams
  });

  const getStockInputsWithPaging = useCallback((
    pagingParams: IGetPageRequestParams,
    abortSignal: AbortSignal,
    updateStateAfterFetch: (updateStateParams: IUpdateStateAfterSearchParams) => void
  ): void => {
    dispatch(getStockInputs({
      getInputsRequestParams,
      pagingParams,
      abortSignal,
      updateStateAfterFetch
    }));
  }, [dispatch, getInputsRequestParams]);

  const { doSortBy, resetAfterSearch, lastElementRef, handleScroll
  } = usePagingAndSort(getStockInputsWithPaging, limit,);

  useEffect(() => {
    resetAfterSearch();
  }, [getInputsRequestParams]);

  useEffect(() => {
    dispatch(getStockReservations("dummy parameter"));
  }, [dispatch]);

  return (
    <>
      <Header title="Lager" />
      <Toolbox
        defaultGetInputsRequestParams={defaultGetInputsRequestParams}
        setGetInputsRequestParams={setGetInputsRequestParams}
        registerSearch={registerSearch}
        handleSubmitSearch={handleSubmitSearch}
        resetSearch={resetSearch}
        controlSearch={controlSearch}
        getValuesSearch={getValuesSearch}
        setFocusSearch={setFocusSearch}
        setValueSearch={setValueSearch}
      />
      <main className="lager">
        <TopSection
          lastTableElementRef={lastElementRef}
          handleScroll={handleScroll}
          doSortBy={doSortBy}
          getValuesSearch={getValuesSearch}
        />
        <BottomSection />
      </main>
    </>
  );
};

export default Input;
